const Row = ({ r, label, testid }) => (
  <tr className="border-t border-white/5" data-testid={testid}>
    <td className="py-2 pr-3 font-semibold">{label}</td>
    <td className="pr-3 font-mono text-slate-300">{r.races}</td>
    <td className="pr-3 font-mono">{r.win_pct ?? "—"}{r.win_pct != null && "%"} <span className="text-slate-500 text-xs">({r.top_wins})</span></td>
    <td className="font-mono">{r.place_pct ?? "—"}{r.place_pct != null && "%"} <span className="text-slate-500 text-xs">({r.top_places})</span></td>
  </tr>
);

export const BreakdownTable = ({ title, rows, kind }) => (
  <section className="rounded-2xl bg-[#131C31] border border-white/5 p-5 overflow-x-auto" data-testid={`record-by-${kind}`}>
    <h2 className="font-display text-base md:text-lg font-bold mb-2">{title}</h2>
    {rows.length === 0 ? <p className="text-sm text-slate-500">No results yet.</p> : (
      <table className="w-full text-sm">
        <thead><tr className="text-left text-[11px] uppercase tracking-widest text-slate-500"><th className="py-1 pr-3">{kind === "state" ? "State" : "Track"}</th><th className="pr-3">Races</th><th className="pr-3">Top pick won</th><th>Top 3</th></tr></thead>
        <tbody>{rows.map((r) => <Row key={r.key} r={r} label={kind === "track" && r.state ? `${r.key} (${r.state})` : r.key} testid={`record-${kind}-${r.key.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />)}</tbody>
      </table>
    )}
  </section>
);
